import { TableRow, TableCell, Skeleton } from '@mui/material';

interface TableSkeletonProps {
  rowsNumber: number;
  colsNumber: number;
}

function TableSkeleton({ rowsNumber, colsNumber }: TableSkeletonProps) {
  let skeleton = [...Array(rowsNumber)].map((row, rowIndex) => (
    <TableRow key={rowIndex} sx={{ height: '100px' }}>
      {[...Array(colsNumber)].map((col, colIndex) => (
        <TableCell key={`${rowIndex}-${colIndex}`} component="td" scope="row">
          <Skeleton animation="wave" variant="text" />
        </TableCell>
      ))}
    </TableRow>
  ));

  return <>{skeleton}</>;
}

export default TableSkeleton;
